/**
 * Initialization and options for Splide js
 */
function splider() {
  const homepageSlider = document.querySelector('.homepage__slider-content');
  if (homepageSlider) {
    const homepageProductSlider = new Splide(homepageSlider, {
      perPage: 2,
      gap: 22,
      breakpoints: {
        980: {
          gap: 15,
        },
        767: {
          perPage: 1,
        },
      },
    });
    homepageProductSlider.mount();
  }
}
splider();

/**
 * Swatch Function when clicked
 */
function swatchColor() {
  let swatchBlocks = document.querySelectorAll('.homepage__slider-block-swatch');
  let imageBlocks = document.querySelectorAll('.homepage__slider-content-block');

  swatchBlocks.forEach(function (block) {
    block.addEventListener('click', function (event) {
      let clickedSpan = event.target.closest('.homepage__slider-swatch');

      if (clickedSpan) {
        resetSwatch(block);
        clickedSpan.classList.add('homepage__slider-swatch--active');
        let swatchClicked = clickedSpan.getAttribute('data-swatch');

        imageBlocks.forEach(function (block) {
          block.addEventListener('click', () => {
            let variantImages = block.querySelectorAll('.homepage__slider-block-img');
            variantImages.forEach(function (img) {

              if (img.getAttribute('data-color') == swatchClicked) {
                resetImageVariant();
                img.classList.add('homepage__slider-block-img--active');
              }
            });

            function resetImageVariant() {
              variantImages.forEach(function (img) {
                img.classList.remove('homepage__slider-block-img--active');
              });
            }
          });
        });
      }
    });
  });

  function resetSwatch(block) {
    let swatches = block.querySelectorAll('.homepage__slider-swatch');

    swatches.forEach(function (swatch) {
      swatch.classList.remove('homepage__slider-swatch--active');
    });
  }
}
swatchColor();